// extracted by mini-css-extract-plugin
module.exports = {"main":"accordion_main__3gVLa","title":"accordion_title__vTg9W"};